<template>
  <div>
    <div>
      <div class="search-wrap">
<!--        <el-button size="mini" @click="search">查询</el-button>-->
<!--        <el-button size="mini" @click="ERP.navigateTo('/meter/meterNoteExcel?type='+($route.query.type||0))" style="margin-right: 5px;" v-if="ERP.isPermission(4007002002)">抄表</el-button>-->
        <el-button size="mini" @click="getPrint" style="margin-right: 5px;" >打印</el-button>
      </div>

      <div style="margin-bottom: 10px;">
        <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'43%'}">
          <el-descriptions-item label="仪表编号">
            <el-input size="mini" placeholder="请输入仪表编号" v-model="where.number" clearable @change="pageChange(1)"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="当前房产">
            <el-input size="mini" placeholder="请选择房产" v-model="where.house_name" clearable @change="pageChange(1)"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="仪表状态">
            <el-checkbox-group v-model="where.status_ids" @change="pageChange(1)">
              <el-checkbox v-for="item in [{name:'在用',val:1},{name:'停用',val:2}]" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
          <el-descriptions-item label="仪表名称">
            <el-input size="mini" placeholder="请输入仪表名称" v-model="where.name" clearable @change="pageChange(1)"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="仪表类型">
            <el-select size="mini" style="width: 100%" v-model="where.meter_type" filterable placeholder="类型" class="kuan" @change="pageChange(1)">
              <el-option
                v-for="item in meter_type_list"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="仪表性质">
            <el-checkbox-group v-model="where.meter_nature_ids" @change="pageChange(1)">
              <el-checkbox v-for="item in meter_nature_list" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
          <el-descriptions-item label="审核标志">
            <el-checkbox-group v-model="where.is_examine_ids" @change="pageChange(1)">
              <el-checkbox v-for="item in [{name:'未审核',val:0},{name:'已审核',val:1}]" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
          <el-descriptions-item label="能耗类型">
            <el-checkbox-group v-model="where.energy_ids" @change="pageChange(1)">
              <el-checkbox v-for="(item,index) in energy_list" :disabled="!isEnergyAble(item.val)" :label="item.val" :key="index">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
          <el-descriptions-item label="抄表日期">
            <div v-if="where.read_type===2">
              <el-row>
                <el-col :span="11">
                  <el-date-picker
                    style="width: 100%"
                    size="mini"
                    v-model="where.start_time"
                    :clearable="false"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd" @change="pageChange(1)">
                  </el-date-picker>
                </el-col>
                <el-col :span="2">
                  至
                </el-col>
                <el-col :span="11">
                  <el-date-picker
                    style="width: 100%"
                    size="mini"
                    v-model="where.end_time"
                    :clearable="false"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd" @change="pageChange(1)">
                  </el-date-picker>
                </el-col>
              </el-row>
            </div>
            <div v-if="where.read_type===1">
              <el-date-picker
                style="width: 100%"
                size="mini"
                v-model="where.read_month"
                :clearable="false"
                type="month"
                format="yyyy-MM"
                value-format="yyyy-MM" @change="pageChange(1)">
              </el-date-picker>
            </div>
            <div style="margin-top: 10px;">
              <el-radio v-model="where.read_type" :label="1">按月</el-radio>
              <el-radio v-model="where.read_type" :label="2">自定义</el-radio>
              <el-radio v-model="where.time_type" :label="1">抄表日期</el-radio>
              <el-radio v-model="where.time_type" :label="2">登记日期</el-radio>
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <div>
        <el-table v-if="pageData" v-loading="loading" border width="99%" height="47vh" :data="pageData.list" @selection-change="handleSelectionChange">
          <el-table-column prop="id" label="id"  width="50" fixed></el-table-column>
          <el-table-column prop="house_name" label="所在房产" width="200" fixed></el-table-column>
          <el-table-column prop="number" label="仪表编号 " width="100" fixed>
            <template slot-scope="scope">
              <el-link type="primary" @click="edit(scope.row)">{{scope.row.number}}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="仪表名称 " width="100"></el-table-column>
          <el-table-column prop="meter_type_name" label="仪表类型"  width="100"></el-table-column>
          <el-table-column prop="charging_standard_name" label="收费标准 " width="250"></el-table-column>
          <el-table-column prop="charging_standard_money" label="单价 " width="100"></el-table-column>
          <el-table-column prop="read_number" label="本期读数" width="100">
          </el-table-column>
          <el-table-column prop="dosage_number" label="本期用量" width="100"></el-table-column>
          <el-table-column prop="read_time" label="抄表日期" width="100"></el-table-column>
          <el-table-column prop="mn_remarks" label="备注" width="100"></el-table-column>
          <el-table-column prop="last_year_dosage_number" label="去年同期用量" width="140">
            <template slot-scope="scope">
              <span>{{scope.row.last_year_dosage_number}}</span>
              <span style="color: #ff1818;" v-if="scope.row.tong_bi>(scope.row.last_year_dosage_number/2)">{{scope.row.tong_bi}} ↑</span>
              <span style="color: #3b6ed9;" v-if="scope.row.tong_bi<-(scope.row.last_year_dosage_number/2)">{{scope.row.tong_bi}} ↓</span>
            </template>
          </el-table-column>
          <el-table-column prop="last_dosage_number" label="上期用量" width="140">
            <template slot-scope="scope">
              <span>{{scope.row.last_dosage_number}}</span>
              <span style="color: #ff1818;" v-if="scope.row.huan_bi>(scope.row.last_dosage_number/2)">{{scope.row.huan_bi}} ↑</span>
              <span style="color: #3b6ed9;" v-if="scope.row.huan_bi<-(scope.row.last_dosage_number/2)">{{scope.row.huan_bi}} ↓</span>
            </template>
          </el-table-column>
          <el-table-column prop="mn_admin_name" label="抄表人" width="100"></el-table-column>
          <el-table-column prop="is_examine" label="审核" width="100">
            <template slot-scope="scope">
              {{scope.row.is_examine?'已审':'未审'}}
            </template>
          </el-table-column>
          <el-table-column prop="mn_files" label="图片" width="100">
            <template slot-scope="scope">
              <el-popover v-if="scope.row.mn_files.length>0"
                          placement="right"
                          width="500"
                          trigger="hover">
                <div>
                  <el-carousel indicator-position="outside">
                    <el-carousel-item v-for="(item,index) in scope.row.mn_files" :key="index">
                      <el-image fit="scale-down" style="width: 480px; " :src="item"></el-image>
                    </el-carousel-item>
                  </el-carousel>

                </div>
                <el-image slot="reference" v-for="(item,index) in scope.row.mn_files" :key="index"
                          style="width: 80px; height: 80px"
                          :src="scope.row.mn_files[0]"
                          fit="cover"></el-image>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="操作 " width="180">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="showAnalysis(scope.row)" >能耗分析</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="margin-top: 20px;text-align: right;margin-right: 20px;">
        <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
      </div>
    </div>

    <MeterInfo ref="MeterInfo" />

    <ViewFile ref="ViewFile" />

    <MeterNoteAnalysisWindow ref="MeterNoteAnalysisWindow" />
  </div>
</template>

<script>
import ViewFile from "../../../Common/ViewFile";
import UploadFilesSysc from "../../../Contract/components/UploadFilesSysc";
import moment from "moment";
import MeterInfo from "../meter/components/MeterInfo";
import MeterNoteAnalysisWindow from "./components/MeterNoteAnalysisWindow";
import CommonMixin from "../../common/CommonMixin";
import MeterHttp from "../../common/MeterHttp";
export default {
  name: "MeterNoteDetail",
  components: {MeterNoteAnalysisWindow, MeterInfo, ViewFile, UploadFilesSysc},
  mixins:[CommonMixin],
  inject:['mainObj','componentId','setComponentId'],
  data() {
    return {
      host_url: "",
      keyword: '',
      loading: false,
      where: {
        meter_type: "",
        house_name: "",
        number: "",
        charging_standard: "",
        status: "",
        status_ids: [1],
        line: "",
        meter_nature: "",
        meter_nature_ids: [1,2,3,4],
        name: "",
        note_type:"",
        is_accident:"",
        is_examine:"",
        is_examine_ids:[1,0],
        start_time:moment(new Date()).startOf('month').format("YYYY-MM-DD"),
        end_time:moment(new Date()).endOf('month').format("YYYY-MM-DD"),
        read_month:moment(new Date()).endOf('month').format("YYYY-MM"),
        read_type:1,
        time_type:1,
        energy_ids:this.getDefaultEnergyIds(),
      },
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1
      },
      dialogVisible: false,
      treeDialogVisible: false,
      uploadUrl: "",
      month_value: "",
      business_list: [],
      entry_type_name: "",
      multipleSelection: [],
      meter_type_list: [],
      house_charge_list:[],
      chargeItem_name_id:"",
      meter_nature_list:[{name:'分表',val:1},{name:'总表',val:2},{name:'分摊表',val:3},{name:'电力负荷表',val:4}],
      energy_list:[{name:"业主能耗",val:1},{name:"物业能耗",val:2},{name:"分摊能耗",val:3},],
      charging_standard:"",
      mapDialogTableVisible:false,
      updateDialogVisible:false,
      yDialogVisible:false,
      mapCenter:[0,0],
    }
  },
  mounted() {
    const that=this;
    this.host_url = __HTTP__.defaults.baseURL;
    // this.month_value=CommonHelp.date("YYYY-MM");
    this.getMeterTypeList()

    this.where.house_name=that.mainObj.house_name;
    this.where.house_name&&this.getList();
  },
  watch: {
    "where.meter_type":function (n) {
      this.chargeItem_name_id=(this.meter_type_list.find(ret=>{ return ret.id===n })||{}).expenditure_id||"";
      this.getHouseChargeList();
    },
    "mainObj.house_name":function (n) {
      const that=this;
      this.where.house_name=n;
      this.getList();
    }
  },
  computed: {
    multipleSelection_meter_ids(){
      return this.multipleSelection.map(ret=>{
        return ret.mn_id
      });
    },
    multipleSelection_meter_examine_type_num(){
      let set=new Set();
      this.multipleSelection.map(ret=>{
        set.add(ret.is_examine)
      });
      return Array.from(set).length;
    },
    multipleSelection_meter_examine(){
      return this.multipleSelection.filter(ret=>{
        return !!ret.is_examine
      });
    },
    multipleSelection_meter_not_examine(){
      return this.multipleSelection.filter(ret=>{
        return !ret.is_examine
      });
    },
  },
  methods: {
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      var that = this;
      that.loading = true;
      let where = reObject(this.where);
      MeterHttp.get("MeterNote/getList",{
        project_id:that.mainObj.project_id,
        where: JSON.stringify(where),
        user_type:(that.$route.query.type||0),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      }, res => {
        if (res.code) {
          res.data.list=res.data.list.map(ret => {
            ret.mn_files=that.readImages(ret.mn_files)
            return ret;
          })
          that.pageData = res.data
        }
        that.loading = false;
        that.multipleSelection = []
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    edit(item) {
      this.$refs.MeterInfo.show(item);
    },
    setFrom(data){
      const that = this;
      MeterHttp.post("MeterNote/save?user_type="+(that.$route.query.type||0), data, res => {
        that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
        if (res.code) {
          that.getList()
        }
      })
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_id,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    getHouseChargeList(){
      var that=this;
      let where={};
      this.form.project_id&&(where.pindex_id=this.form.project_id);
      this.chargeItem_name_id&&(where.chargeItem_name_id=this.chargeItem_name_id);
      MeterHttp.get("HouseCharge/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      })
    },
    navToMeterExcel(){
      ERP.navigateTo("/meter/meterExcel?type="+(this.$route.query.type||0));
    },
    getPrint(){
      const that = this;
      let where = reObject(this.where);
      MeterHttp.get("MeterNote/getExcelList",{
        project_id:that.mainObj.project_id,
        where: JSON.stringify(where),
        user_type:(that.$route.query.type||0),
      }, res => {
          if (res.code) {
            let file_src=res.data
            console.log(file_src)
            that.$refs.ViewFile.show({
              width: '90vw',
              height:'80vh',
              title:"抄表明细",
              src:file_src,
              download(){
                // TODO 下载文件逻辑
                window.open(file_src)
              }
            })
          }else {
            that.$message.error(res.msg||'导出失败')
          }
      });
    },
    readImages(mn_files){
      if(mn_files){
        let images=mn_files.split(',');
        return images.map(url=>{
          return loadUrl(url);
        })
      }else {
        return [];
      }
    },
    showAnalysis(item){
      this.$refs.MeterNoteAnalysisWindow.show(item.id,item.number+"_"+item.name)
    }
  }
}

function reObject(item) {
  return JSON.parse(JSON.stringify(item));
}
function loadUrl(url){
  return "http://engineering.gdzawy.com:9000/admin/public"+url;
}
</script>

<style lang="scss" scoped>
@import "../../common";
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_note/MeterNoteDetail.vue